/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ store: NonNullable<unknown> }} Dialog_Open_StoreInputs */

const en_dialog_open_store = /** @type {(inputs: Dialog_Open_StoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open ${i?.store}`)
};

const es_dialog_open_store = /** @type {(inputs: Dialog_Open_StoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir ${i?.store}`)
};

/**
* | output |
* | --- |
* | "Open {store}" |
*
* @param {Dialog_Open_StoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_open_store = /** @type {((inputs: Dialog_Open_StoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Open_StoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_open_store(inputs)
	return en_dialog_open_store(inputs)
});